import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row } from "react-bootstrap";
import FormSection from "components/v2/FormSection/FormSection";
import Organisational from "pages/shipper/RequestForm/components/Confirmation/organisational";
import Schedule from "pages/shipper/RequestForm/components/Confirmation/Schedule";
import Service from "pages/shipper/RequestForm/components/Confirmation/Service";
import FreightMode from "pages/shipper/RequestForm/components/Confirmation/FreightMode";
import Attachment from "pages/shipper/RequestForm/components/Confirmation/Attachment";
import Textarea from "components/atoms/Textarea/Textarea";

function ShipmentSummary({ state }: any) {
  const intl = useIntl();

  return (
    <div className="mt-3xl">
      <FormSection>
        <div className="form-section-content mt-3xl">
          <Row>
            <Col>
              <div className="text-lg font-semibold mb-4">
                <FormattedMessage id="new-request.index.organisation" defaultMessage="Organisation" />
              </div>
              <Organisational state={state} />
            </Col>
            <Col>
              <div className="text-lg font-semibold mb-4">
                <FormattedMessage id="quote-request-detail.schedule" defaultMessage="Schedule" />
              </div>
              <Schedule />
            </Col>
          </Row>
          <Row className="mt-5">
            <Col>
              <div className="text-lg font-semibold mb-4">
                <FormattedMessage id="quote-request-detail.service" defaultMessage="Service" />
              </div>
              <Service state={state} isQuoteRequest />
            </Col>
            <Col>
              <div className="text-lg font-semibold mb-4">
                <FormattedMessage id="general.freightMode" defaultMessage="Freight mode" />
              </div>
              <FreightMode state={state} />
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="text-lg font-semibold mb-4">
                <FormattedMessage id="new-request.attachments.attachment.attachments" defaultMessage="Attachments" />
              </div>
              <Attachment />
            </Col>
            <Col>
              <div className="text-lg font-semibold mb-4">
                <FormattedMessage id="quote-request-detail.Commentary" defaultMessage="Commentary" />
                <div>
                  <Textarea
                    name="shipment.comments"
                    placeholder={intl.formatMessage({
                      id: "general.typeHere",
                      defaultMessage: "Type here...",
                    })}
                    rows={3}
                    className="text-body bg-white mt-3"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </FormSection>
    </div>
  );
}

export default ShipmentSummary;
